export const productList = [
    {
        "id": "document-ocr",
        "name": "Document OCR",
        "desc": "Easily retrieve information from an Image document",
        "logo_url": "/products/document-ocr.png"
    },
    {
        "id": "inno-image-quality-analysis",
        "name": "Image Quality Analysis",
        "desc": "Analyze and share image quality details",
        "logo_url": "/products/ocr.png"
    },
    {
        "id": "inno-fm",
        "name": "Face Match",
        "desc": "Analyze faces from two different sources and produce a similarity score.",
        "logo_url": "/products/face-match.png"
    }, {
        "id": "inno-ocr",
        "name": "Image OCR",
        "desc": "Easily retrieve information from an image of Aadhar card, Driver's license, Voter ID, or PAN card.",
        "logo_url": "/products/ocr.png"
    },
    {
        "id": "inno-face-analysis",
        "name": "Face Analysis",
        "desc": "Determine the liveness, degree of blurriness, presence of objects, and count of faces in a selfie",
        "logo_url": "/products/face-match.png"
    },
    {
        "id": "inno-face-search",
        "name": "Face Search",
        "desc": "Effortlessly find faces in a sea of photos with our advanced face search tool. Instantly locate any face with precision and ease.",
        "logo_url": "/products/face-search.png"
    },
    {
        "id": "inno-aadhar-masking",
        "name": "Aadhar Masking",
        "desc": "Precisely mask the initial eight digits of the Aadhar number within an image of an Aadhar Card.",
        "logo_url": "/products/aadhar-masking.png"
    },
    {
        "id": "inno-spam-classifier",
        "name": "Spam Classifier",
        "desc": "99% Spam-Free Security!",
        "logo_url": "/products/spam-classifier.png"
    },
    {
        "id": "inno-gist",
        "name": "GIST",
        "desc": "Your PDF AI - like ChatGPT but for PDFs Summarize and answer questions.",
        "logo_url": "/products/gist.png"
    },
    {
        "id": "inno-ckyc-cropping",
        "name": "CKYC",
        "desc": "Remove the necessity for customers to go through repetitive KYC procedures when dealing with various financial institutions",
        "logo_url": "/products/ckyc-cropping.png"
    },
    {
        "id": "inno-video-kyc",
        "name": "Video KYC",
        "desc": "Enroll users from a distance via video achieving a high level of confidence, with or without agent assistance, all while maintaining compliance.",
        "logo_url": "/products/video-kyc.png"
    },
    {
        "id": "inno-vid-verification",
        "name": "Voter ID Verification",
        "desc": "Verify Indian Voter ID",
        "logo_url": "/products/voter-id-verification.png"
    },
    {
        "id": "inno-face-liveness",
        "name": "Face Liveness",
        "desc": "Real-time verification ensuring living presence for secure facial recognition.",
        "logo_url": "/products/face-liveness.png"
    },
    {
        "id": "inno-address-match",
        "name": "Address Match",
        "desc": "Efficient address validation for accurate data matching and verification solutions.",
        "logo_url": "/products/address-match.png"
    },
    {
        "id": "inno-sdks",
        "name": "SDK",
        "desc": "SDK available for different languages and platform",
        "logo_url": "/products/sdk.png"
    },
    {
        "id": "inno-moderation",
        "name": "Moderation Service",
        "desc": "Automated content review for a safe and compliant online environment",
        "logo_url": "/products/nsfw.png"
    },
    {
        "id": "inno-aifise-onboarding",
        "name": "Onboarding Process",
        "desc": "Effortless Onboarding, Empowering Success: Navigate the Future with Seamless Transitions.",
        "logo_url": "/products/onboarding-process.png"
    },
    // {
    //     "id": "inno-mis",
    //     "name": "MIS",
    //     "desc": "MIS Management for aifise products",
    //     "logo_url": "/products/mis.png"
    // }
]